/**
 * Customer Account Section
 * Handles tab switching and form interactions
 */

import { gsap } from "gsap";

export default class CustomersAccount {
  constructor(container) {
    this.container = container;
    this.tabs = this.container.querySelectorAll('[data-tab]');
    this.panels = this.container.querySelectorAll('[data-panel]');
    this.currentTab = 'details';

    this.init();
    this.events();
  }

  init() {
    // Optional: Add entrance animation for orders when orders tab is active
    const ordersPanel = this.container.querySelector('[data-panel="orders"]');
    if (ordersPanel) {
      const orders = ordersPanel.querySelectorAll('.customer-account__order');
      if (orders.length > 0 && ordersPanel.classList.contains('customer-account__panel--active')) {
        gsap.set(orders, { opacity: 0, y: 20 });
        gsap.to(orders, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power2.out'
        });
      }
    }
  }

  events() {
    // Tab click events
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const tabName = tab.dataset.tab;
        this.switchTab(tabName);
      });
    });
  }

  switchTab(tabName) {
    if (tabName === this.currentTab) return;

    // Update tabs
    this.tabs.forEach(tab => {
      if (tab.dataset.tab === tabName) {
        tab.classList.add('customer-account__tab--active');
      } else {
        tab.classList.remove('customer-account__tab--active');
      }
    });

    // Update panels
    this.panels.forEach(panel => {
      if (panel.dataset.panel === tabName) {
        panel.classList.add('customer-account__panel--active');
        panel.style.display = 'block';

        // Animate panel in
        gsap.fromTo(panel,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, duration: 0.3, ease: 'power2.out' }
        );

        // Animate orders if switching to orders tab
        if (tabName === 'orders') {
          const orders = panel.querySelectorAll('.customer-account__order');
          if (orders.length > 0) {
            gsap.set(orders, { opacity: 0, y: 20 });
            gsap.to(orders, {
              opacity: 1,
              y: 0,
              duration: 0.6,
              stagger: 0.1,
              ease: 'power2.out',
              delay: 0.1
            });
          }
        }
      } else {
        panel.classList.remove('customer-account__panel--active');
        panel.style.display = 'none';
      }
    });

    this.currentTab = tabName;
  }
}

